export const createUUID = (): number => {
  return getRandomInt(5000, 99999);
};

function getRandomInt(min: number, max: number) {
  const minR = Math.ceil(min);
  const maxR = Math.floor(max);
  return Math.floor(Math.random() * (maxR - minR) + minR);
}
